import { Content } from 'antd/es/layout/layout';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import SmallHeader from 'modules/shop-front/shop-front-component/SmallHeader';
import ShopFrontFooter from 'modules/shop-front/shop-front-component/ShopFrontFooter';
import ShopFrontHeaderSticky from 'modules/shop-front/shop-front-component/ShopFrontHeaderSticky';
import SmallHeaderSticky from 'modules/shop-front/shop-front-component/SmallHeaderSticky';
import ModalAuth from 'modules/auth/modal-auth/ModalAuth';

const ShopFrontLayoutWrapper: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const navigate = useNavigate();

  return (
    <Content className="bg-white hedvig-letters-sans-regular ">
      <ShopFrontHeaderSticky></ShopFrontHeaderSticky>
      <SmallHeaderSticky></SmallHeaderSticky>
      <ModalAuth></ModalAuth>
      <div className="mt-32 sm:mt-40 mb-32">
        <Outlet />
      </div>
      {/* <button
        onClick={() => {
          navigate('/contact');
        }}
        className="group flex flex-row gap-2 items-center fixed bottom-0 right-0 z-50 px-5 py-1 mr-5 mb-5 transform text-black text-xl rounded-md  bg-transparent  hover:bg-neutral-300 transition-transform duration-300 w-fit hover:-translate-y-1 border-none"
      >
        <div className="absolute inset-0 bg-black opacity-10 rounded-md group-hover:opacity-0"></div>
        <div className="w-2.5 h-2.5 bg-green-500 rounded-full mr-2"></div>{' '}
        Contact Us
      </button> */}
      <ShopFrontFooter></ShopFrontFooter>
    </Content>
  );
};

export default ShopFrontLayoutWrapper;
